<vdms-hq-ui-dialog-wrapper>
  <h1 title>{{ (isEditMode ? 'pages.fields.edit_field' : 'pages.fields.create_field') | translate }}</h1>
  <form content [formGroup]="form" class="fit-inputs metadata-wrapper">
    @if (!isSelfServiceMode && !isEditMode && isSuperAdmin()) {
      <div class="global-field-warning-box">
        <vdms-hq-ui-info-bar
          [type]="InfoBarType.WARNING"
          [message]="'pages.fields.global_visibility_warning' | translate"
        />

        <!-- Only super admins can CREATE a global field -->
        <vdms-hq-ui-form-input-toggle
          formControlName="is_global"
          [label]="'pages.fields.columns.is_global' | translate"
          [withFooter]="false"
        />
      </div>
    }

    <!-- Only when creating a new field, the type can be selected -->
    <vdms-hq-ui-form-input-select
      [label]="'pages.fields.columns.type' | translate"
      formControlName="type_uuid"
      [selectOptions]="types$ | async"
    />

    @if (form.controls.type_uuid.value) {
      @if (data.selfServiceMode) {
        <vdms-hq-ui-form-input-select
          formControlName="label"
          [label]="'pages.fields.columns.label' | translate"
          [selectOptions]="(autocompleteOptions$ | async) ?? []"
          [emptyIcon]="'none'"
          [actionBtnText]="'pages.fields.add_label_action' | translate"
          [emptyMessage]="'pages.fields.no_duplicate_labels' | translate"
          (actionBtn)="addLabel($event)"
          [showEmptyResultsWithNoSelectOptions]="true"
          [customErrorMessages]="{ duplicateLabel: 'common.validators.duplicateLabel' }"
        />
      } @else {
        <vdms-hq-ui-form-input-text
          formControlName="label"
          [label]="'pages.fields.columns.label' | translate"
          [customErrorMessages]="{
            noQuotes: 'common.validators.noQuotes',
            duplicateLabel: 'common.validators.duplicateLabel',
          }"
        />
      }

      @if (data.fieldValue) {
        <vdms-hq-ui-form-input-text-area
          formControlName="description"
          [label]="'pages.fields.columns.description' | translate"
        />

        <vdms-hq-ui-form-input-select
          [label]="'pages.fields.columns.parent_field_type' | translate"
          formControlName="parent_field_type_name"
          [selectOptions]="(parentTypeNames$ | async) ?? []"
          [enableClear]="true"
          [showAlwaysClear]="true"
          [sharedE2eId]="'field-value-parent-type'"
        />

        @if (
          form.value.parent_field_type_name && allFields$
            | async
            | fieldValueByTypeToSelectOptions: form.value.parent_field_type_name;
          as options
        ) {
          <vdms-hq-ui-form-input-select
            [label]="'pages.fields.columns.parent_field_value' | translate"
            formControlName="parent_field_uuid"
            [selectOptions]="options"
            [enableClear]="true"
            [showAlwaysClear]="true"
            [sharedE2eId]="'field-value-parent-value'"
          />
        }

        <ng-container formGroupName="extra">
          <vdms-hq-selectors-field-values-edit-extra formControlName="siblings" />

          <vdms-hq-ui-form-input-select
            [label]="'pages.fields.columns.restricted' | translate"
            formControlName="restricted"
            [selectOptions]="assetMasterTypes"
            [enableClear]="true"
            [multiple]="true"
          />
        </ng-container>
      }
    }
  </form>

  <ng-container footer>
    <vdms-hq-ui-button color="secondary" (click)="cancel()">{{ 'common.global.cancel' | translate }}</vdms-hq-ui-button>
    <vdms-hq-ui-button color="primary" (click)="save()" [loading]="isSaving()" [disabled]="isSaveDisabled">
      {{ 'common.global.save' | translate }}
    </vdms-hq-ui-button>
  </ng-container>
</vdms-hq-ui-dialog-wrapper>
